"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchClientFactory = exports.getBody = exports.getProcessorType = exports.getContentType = void 0;
require("isomorphic-fetch");
const querystring_1 = __importDefault(require("querystring"));
const errors_1 = require("./errors");
const normalizeUrl_1 = require("@clcdev/web-core-utils/lib/normalizeUrl");
/* helps determine content-type for requests/responses */
// text/javascript; charset=utf8
const getContentType = (contentType, defaultContentType) => {
    var _a, _b, _c;
    return ((_c = (_b = (_a = (contentType || defaultContentType)) === null || _a === void 0 ? void 0 : _a.split(",").shift()) === null || _b === void 0 ? void 0 : _b.split(";").shift()) === null || _c === void 0 ? void 0 : _c.trim());
};
exports.getContentType = getContentType;
/* get content return type, one of: "json" | "text" | "blob" | "arrayBuffer" */
const getProcessorType = (contentType, defaultContentType) => {
    const checkContentType = (0, exports.getContentType)(contentType, defaultContentType);
    switch (checkContentType) {
        case "text/javascript":
        case "text/html":
        case "text/plain":
            return "text";
        default:
            return "json";
    }
};
exports.getProcessorType = getProcessorType;
/* parse request body to match request content-type */
const getBody = (contentType, body) => {
    switch (contentType) {
        case "application/json":
            return JSON.stringify(body);
        default:
            return querystring_1.default.stringify(body);
    }
};
exports.getBody = getBody;
const getResponseBody = (body, contentType) => {
    try {
        switch (contentType) {
            case "json": {
                return JSON.parse(body);
            }
        }
    }
    catch (e) {
        // noop
    }
    return body;
};
const resolveHeaders = async (headers) => {
    if (typeof headers === "function") {
        return await headers();
    }
    return headers;
};
const fetchClientFactory = (baseUrl, defaultOptions = {}) => (async (pathname, options = {}) => {
    const { queryParams, } = options;
    const targetUrl = (0, normalizeUrl_1.normalizeUrl)(baseUrl + pathname);
    const queryString = querystring_1.default.stringify(Object.assign({}, defaultOptions.queryParams || {}, queryParams || {}));
    const defaultHeaders = await resolveHeaders(defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.headers) || {};
    const clientHeaders = await resolveHeaders(options === null || options === void 0 ? void 0 : options.headers) || {};
    const headers = Object.assign({}, defaultHeaders, clientHeaders);
    const normalizedHeaders = Object.entries(headers)
        .reduce((acc, [key, val]) => {
        const normalizedKey = key.toLowerCase();
        acc[normalizedKey] = val;
        return acc;
    }, {});
    const requestHeaders = new Headers(normalizedHeaders);
    const body = (0, exports.getBody)((0, exports.getContentType)(requestHeaders.get("Content-Type")), options.body);
    let response;
    try {
        response = await fetch([targetUrl, queryString].filter(Boolean).join("?"), {
            ...defaultOptions,
            ...options,
            headers: requestHeaders,
            body,
        });
    }
    catch (err) {
        throw new errors_1.RequestError(`Failed request to ${targetUrl}`, err, body);
    }
    const responseBody = getResponseBody(await response.text(), (0, exports.getProcessorType)(response.headers.get("Content-Type"), requestHeaders.get("Accept")));
    /* throw ResponseError if resp was unsuccessful (not in 200 - 299 range) */
    if (!response.ok) {
        throw new errors_1.ResponseError("Received error response", new Error("Returned unsuccessful response"), responseBody);
    }
    return responseBody;
});
exports.fetchClientFactory = fetchClientFactory;
//# sourceMappingURL=fetch-client.js.map